module.exports = __webpack_public_path__ + "img/new_age_banner.92bad731.jpg";